var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',{attrs:{"disabled":_vm.disabled,"placeholder":_vm.placeholder},on:{"select":_vm.handleSelect,"blur":_vm.handleBlur},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}},_vm._l((_vm.list),function(item){return _c('a-select-option',{key:item.name},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }